import { setupWorker } from "msw";
import { handlers } from "./handlers";

// 創建 MSW worker
export const worker = setupWorker(...handlers);

// 啟動函數
export function startMockWorker() {
  return worker.start({
    onUnhandledRequest: "bypass",
    serviceWorker: {
      url: "/mockServiceWorker.js",
    },
    quiet: false,
  });
}
